import { connect } from 'react-redux';
import PagesView from './index'
import {updateStreaming, loadStreamings, removeStreaming} from '../../actions/Streamings'


const mapStateToProps = (state, props) => {
    
    return {
	streamings: state.streamings.list
    }
}

const mapDispatchToProps = (dispatch, state) => {
    return {
	loadStreamings: () => {
	    return dispatch(loadStreamings());
	},
	removeStreaming: (id) => {
	    return dispatch(removeStreaming(id)).then(() => dispatch(loadStreamings()));
	},
	updateStreaming: (streaming) => {
	    return dispatch(updateStreaming(streaming)).then(() => dispatch(loadStreamings()));
	}
    }
}

const PagesContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PagesView);




export default PagesContainer;



// WEBPACK FOOTER //
// ./src/components/Streamings/Container.js